import Trans from 'next-translate/Trans';

// Libs
import { discoverContent } from '@/lib/discover/content';
import mainFacebook from '@/lib/menu/mainFacebook';
import mainInstagram from '@/lib/menu/mainInstagram';
import mainLinkedin from '@/lib/menu/mainLinkedin';
import mainTiktokBusiness from '@/lib/menu/mainTiktokBusiness';
import mainTwitter from '@/lib/menu/mainTwitter';
import mainYoutube from '@/lib/menu/mainYoutube';
import mainPinterest from '@/lib/menu/mainPinterest';
import {
    FACEBOOK,
    INSTAGRAM,
    LINKEDIN,
    TIKTOK_BUSINESS,
    TWITTER,
    YOUTUBE,
    PINTEREST
} from '@/lib/socialProfile';

// Types
import type { SocialProfileNetworkType } from '@/types/socialProfileType';
import type { UrlObject } from 'url';

export type LinkHrefType = string | UrlObject;

export type MainMenuType = MainMenuEntryType[];

export type MainMenuEntryType = {
    lockedLinks?: Parameters<typeof Trans>[0]['components'];
    disabled?: boolean;
    disabledTooltip?: JSX.Element;
    discoverId?: keyof typeof discoverContent;
    icon?: string;
    link?: LinkHrefType;
    locked?: string;
    lockedTooltip?: string;
    name: string;
    shouldBeDisplayed?: string;
    subMenuItems?: MainMenuType;
    urlActiveMenu?: string[];
    isComingSoon?: boolean;
    quickAccess?: MainMenuQuickAccessType;
};

export type MainMenuQuickAccessType = {
    label: string;
    icon?: string;
    link: LinkHrefType;
    id?: string;
};

export const getMainMenuSocialProfile = (network: SocialProfileNetworkType): MainMenuType => {
    switch (network) {
        case INSTAGRAM:
            return mainInstagram;
        case FACEBOOK:
            return mainFacebook;
        case TWITTER:
            return mainTwitter;
        case LINKEDIN:
            return mainLinkedin;
        case TIKTOK_BUSINESS:
            return mainTiktokBusiness;
        case YOUTUBE:
            return mainYoutube;
        case PINTEREST:
            return mainPinterest;
        default:
            return mainInstagram;
    }
};
